import React, {useContext, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import Modal from "@ui-components/Modal";
import VisibilityEditor from "@pages/WorksitesDocuments/VisibilityEditor";
import Button from "@ui-components/Button";
import CountryContext from "../../CountryContext";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import useAsyncError from "@hooks/useAsyncError";
import Alert from "@ui-components/Alert";

const EditDocumentModal = ({documents, onClose, worksiteUsers, setUserLoadedDocuments, sharing}) => {
  
  if (!documents.length)
    throw new Error("No documents provided");

  // hooks
	const intl = useIntl();
  const throwError = useAsyncError();
  const {country} = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country?.code);

  // utilities
  const buildPayload = (document) => {
    return {
      ...document,
      flg_public: visibilityManagement === "public",
      lst_visibility: visibilityManagement === "manage_visibility" ? visibility : [],
    }
  }

  // state
	const [visibilityManagement, setVisibilityManagement] = useState(
		documents.length > 1 || documents[0].flg_public
      ? "public"
      : "manage_visibility"
	);
	const [visibility, setVisibility] = useState(
    documents.length > 1 || documents[0].flg_public
      ? []
      : documents[0].lst_visibility
  );
	const [submitting, setSubmitting] = useState(false);

  // handlers
  const onSubmit = async () => {
    setSubmitting(true)
    try {

      // call the API
      const updated = await Promise.all(
        documents.map(
          (document) => countryApiRequest.put(
            `/worksite_documents/document/${document.id}`,
            buildPayload(document),
          )
        )
      );

      // update the local state
      setUserLoadedDocuments((prev) => prev.map(
        (group) => ({
          ...group,
          documents: group.documents.map(
            (document) => {
              const updatedDocument = updated
                .find((u) => u.id === document.id);
              return !!updatedDocument ? updatedDocument : document;
            }
          ),
        })
      ))

      // close modal
      onClose();
    }
    catch (e) {
      throwError(e);
    }
    finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal
      title={intl.formatMessage({id: "edit_group"})}
      onExit={onClose}
    >
      <div className="flex flex-col gap-4">
        <h2 className="text-3xl">
          <FormattedMessage id="edit_visibility" />
        </h2>
        {documents.length > 1 && (
          <Alert
            type="info"
            text={intl.formatMessage(
              {id: "multiple_documents_visibility_disclaimer"},
              {n: documents.length},
            )}
          />
        )}
        <VisibilityEditor
          labelKey="document_visibility"
          publicLabelKey="visibile_all_group_users"
          choice={visibilityManagement}
          setChoice={setVisibilityManagement}
          users={worksiteUsers}
          visibility={visibility}
          setVisibility={setVisibility}
          sharing={sharing}
        />
        <div>
          <Button
            full
            styleType={"primary"}
            submitting={submitting}
            onClick={onSubmit}
          >
            {intl.formatMessage({id: "confirm"})}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default EditDocumentModal;